import { CircularProgress } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import {
  APP_CONSTANTS,
  EVENT_TEMPLATE_DATA,
  displayNamesOfEventTypes,
} from 'src/consumer/constants'
import { openInNewTab } from 'src/consumer/helpers/utilFunctions'
import EventTypeCreationForm from 'src/mentor/components/MentorEventsPage/components/eventsListing/EventTypeCreationForm'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { postMPData } from 'src/mentor/services'
import { GenericMentorPortalModalComponent } from '../../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import { MentorEventSummaryComponent } from '../../MentorEventsPage/MentorEventsComponentsAndHelpers'
import {
  EventsPageMainItemsContainer,
  NewEventTypeButton
} from '../../MentorEventsPage/MentorEventsPageStyles'
import { fetchWebinarsForMentors } from '../webinars-utils'

export default function WebinarsListing({
  webinars,
  setWebinars,
  oneOnOnePlans,
  refreshWebinars,
  refreshOneOnOnePlans,
  loading,
}) {
  const { mentorProfileData, mentorClinicAssociationData } = useContext(MentorProfileContext)
  const [eventFormModalOpen, setEventFormModalOpen] = useState(false)
  const [selectedEventData, setSelectedEventData] = useState({})
  const [page, setPage] = useState(0)
  const [hasNextPage, setHasNextPage] = useState(true)
  const [saving, setSaving] = useState(false)

  const handleCopyEventLink = (e, item) => {
    // navigator.clipboard.writeText(item?.shortLink);      // will interfere with mobile app
    navigator.clipboard.writeText(
      `${APP_CONSTANTS.LIVE_APP_URL}/mentor/${mentorProfileData?.slug}/events/${item?.uid}`,
    )
    e.stopPropagation()
  }
  const handleOpenBookingPage = (e, item) => {
    openInNewTab(
      `${APP_CONSTANTS.LIVE_APP_URL}/mentor/${mentorProfileData?.slug}/events/${item?.uid}`,
    )
    e.stopPropagation()
  }

  const handleEventCreation = async (data) => {
    setSaving(true)
    const eventToSend = {
      ...data,
      type: 'webinar',
    }

    const response = await postMPData('/api/secure/teacher/webinar/save', eventToSend)
    if (response?.status === 200) {
      await refreshWebinars()
    }
    setSaving(true)

    // if (data?.uid) {
    //   let indexOfEvent
    //   webinars?.forEach((item, index) => {
    //     if (data.uid === item.uid) {
    //       indexOfEvent = index
    //     }
    //   })

    //   setWebinars((prev) => {
    //     const tempData = [...prev]
    //     tempData[indexOfEvent] = data
    //     return tempData
    //   })
    // } else {
    //   const newEvent = {
    //     ...data,
    //     mentorId: mentorProfileData?.id,
    //     type: 'webinar',
    //   }
    //   setWebinars((prev) => [...prev, newEvent])
    // }

    setEventFormModalOpen(false)
    setSelectedEventData(null)
  }
  async function getNextWebinars() {
    const nextWebinars = await fetchWebinarsForMentors(page + 1)
    console.log('nextWebinars', nextWebinars)
    if (!!nextWebinars && nextWebinars.length > 0) {
      setWebinars((prev) => [...(prev || []), ...nextWebinars])
      setPage((prev) => prev + 1)
    } else {
      setHasNextPage(false)
    }
  }

  function handleCreateWebinar() {
    setEventFormModalOpen(true)
    setSelectedEventData({
      ...EVENT_TEMPLATE_DATA,
      apiParam: 'webinar',
      durationInMins: null,
      postBufferMins: null,
      preBufferMins: null,
      panelIds: null,
      type: 'webinar',
      minUsers: 1,
      maxUsers: 10,
      pricingPlanId: oneOnOnePlans?.[0]?.id,
    })
  }

  const [sentryRef] = useInfiniteScroll({
    hasNextPage,
    onLoadMore: getNextWebinars,
    rootMargin: '0px 0px 20px 0px',
  })

  useEffect(() => {
    console.log({ webinars })
  }, [webinars])

  return (
    <>
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px',
          }}
        >
          <CircularProgress sx={{ color: '#A864FF' }} size={30} />
        </div>
      ) : (
        <>
          <NewEventTypeButton
            style={{ marginTop: '20px', marginLeft: '20px' }}
            onClick={handleCreateWebinar}
          >
            + New Webinar
          </NewEventTypeButton>
          <EventsPageMainItemsContainer>
            {webinars?.map((item, index) => {
              return (
                <MentorEventSummaryComponent
                  key={index}
                  item={item}
                  onClickEvent={() => {
                    setEventFormModalOpen(true)
                    setSelectedEventData(item)
                  }}
                  handleCopyEventLink={handleCopyEventLink}
                  handleOpenBookingPage={handleOpenBookingPage}
                />
              )
            })}
          </EventsPageMainItemsContainer>
          <GenericMentorPortalModalComponent
            newScheduleModalOpen={eventFormModalOpen}
            setNewScheduleModalOpen={setEventFormModalOpen}
            setEventFormModalData={(item) =>
              setSelectedEventData({ ...(item || {}), type: 'webinar' })
            }
          >
            <EventTypeCreationForm
              eventFormModalData={selectedEventData}
              setEventFormModalOpen={setEventFormModalOpen}
              displayNamesOfEventTypes={displayNamesOfEventTypes}
              handleEventCreation={handleEventCreation}
              oneOnOnePlans={oneOnOnePlans}
              refreshOneOnOnePlans={refreshOneOnOnePlans}
              saving={saving}
              mentorClinicAssociationData={mentorClinicAssociationData}
              mentorProfileData={mentorProfileData}
            />
          </GenericMentorPortalModalComponent>
          {hasNextPage && (
            <div
              ref={sentryRef}
              style={{
                display: 'flex',
                flexDirection: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '10px',
                width: '100%',
              }}
            >
              <CircularProgress sx={{ color: '#A864FF' }} size={30} />
            </div>
          )}
        </>
      )}
    </>
  )
}
